import { Routes, Route } from "react-router-dom";
import InstanceListPage from "./list";
import InstanceViewPage from "./view";

function InstancesPage() {
	return (
		<Routes>
			<Route index element={<InstanceListPage />} />
			<Route path="/:id" element={<InstanceViewPage />} />
		</Routes>
	);
}

export default InstancesPage;
